import React, { useEffect, useState } from "react";
import { Button, Modal, Switch, List, notification } from "antd";
import {
  useGetCustomersByAliasMutation,
  useTriggerCommandMutation,
} from "../../../services/segmentation.services";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatName } from "../../../utils/helpers";
import moment from "moment";
import { errorBlock } from "../../../controllers/errorBlock";
const TONModal = ({
  open,
  setOpen,
  alias,
  setresult,
  setopenresult,
  intialCommand,
  setcommand,
}) => {
  const [
    getCustomersByAlias,
    { isLoading: segmentloadin, data: segmentdata, error: segmenterror },
  ] = useGetCustomersByAliasMutation();
  const { name: domainname } = useSelector((state) => state.domain);
  const { username } = useSelector((state) => state.userDetails);
  const [meter, setmeter] = useState("");
  const [checked, setchecked] = useState(false);
  const { siteid } = useSelector((state) => state.projectSite);
  const [triggerCommand, { isLoading, error, isError, data }] =
    useTriggerCommandMutation();
  useEffect(() => {
    // console.log(alias, "alias");
    getCustomersByAlias({ alias, siteid })
      .then((res) => {
        if (res.error) {
          console.log(res.error);
        } else {
          console.log(res.data);
        }
      })
      .catch((err) => {});
  }, [alias]);

  const handleSubmit = () => {
    triggerCommand({
      alias,
      commandType: "TON",
      transactiontopic: domainname + "/mqtt_" + username,
      siteid,
    })
      .then((res) => {
        if (res.error) {
          notification.error({
            message: "Failed",
            description: "Failed to complete command",
          });
          return;
        } else {
          //   console.log(res.data, "response");
          setresult(res.data);
          setopenresult(true);
          setcommand(intialCommand);
        }
      })
      .catch((res) => {
        errorBlock(res);
      });
  };

  return (
    <Modal
      open={open}
      title="Turn on customer segments meters"
      footer={null}
      //   onOk={handleOk}
      onCancel={() => setOpen(null)}
    >
      <div className="flex items-center justify-between">
        <div className="">
          <p className="font-semibold m-0">Turn on meters</p>
          <p className="text-[12px] font-light m-0">
            Click on the switch to turn on all meters in {alias}
          </p>
        </div>

        <Switch
          defaultChecked={checked}
          loading={isLoading}
          onChange={handleSubmit}
        />
      </div>

      <List
        header={<strong>Customer Details in segment</strong>}
        bordered={false}
        dataSource={segmentdata?.customers ?? []}
        renderItem={(item) => (
          <List.Item className="flex justify-between">
            <div className="">
              <p className="m-0">
                {formatName(item?.firstName)} {formatName(item?.lastName)}
              </p>
              <Link
                to={"/meter-details/peter/" + item?.meterNumber}
                className="text-black underline "
              >
                {item?.meterNumber ?? ""}
              </Link>
            </div>
            <div
              className={
                "rounded-full bg-blue-100 text-blue-900 p-[5px] text-xs"
              }
            >
              {item.customerType}
            </div>
          </List.Item>
        )}
      />
    </Modal>
  );
};
export default TONModal;
